module.exports = __webpack_public_path__ + "static/media/atlas.48b9fb92.svg";